module.exports = __webpack_public_path__ + "static/media/pressure.4f1ee53a.svg";